import getContextNodesFromChildren from "./getContextNodesFromChildren";

export default function getContexts(children) {
  const contextNodes = getContextNodesFromChildren(children);

  return contextNodes.map((provider) => {
    const { elementType } = provider;

    return {
      context: elementType?._context,
      displayName: elementType?._context.displayName,
      memoizedValues: provider.memoizedProps?.value,
    };
  });
}
